import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { convertToLocalDate } from '../../core';


/**
 * This service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

	readonly DELIMITER = '/';

	override parse(value: string): NgbDateStruct | null {
		if (value) {
			let date = value.split(this.DELIMITER);
			return {
				day: Number.parseInt(date[0], 10),
				month: Number.parseInt(date[1], 10),
				year: Number.parseInt(date[2], 10)
			};
		}
		return null;
	}

	override format(date: NgbDateStruct | null): string {
		return date ? convertToLocalDate(new Date(date.year, date.month - 1, date.day)) : '';
	}
}